let DATA = {
   query: '',
   model: null,
   brand: null,
   timeout: null,
}

function isValidUrl(string) {
   try {
      new URL(string)
      return true
   } catch (_) {
      return false
   }
}

function getProduct(product) {
   const container = document.createElement('div')
   container.className = 'item'

   const meta = document.createElement('div')
   const category = document.createElement('p')
   const code = document.createElement('p')
   const title = document.createElement('a')
   const img = document.createElement('img')

   code.innerText = product.code
   title.href = `/product/view/${product.objectID}`

   code.className = 'sku'
   title.className = 'title'
   meta.className = 'meta'

   category.innerText = product.category
   title.innerText = product.title
   img.src = isValidUrl(product.thumbnail) ? product.thumbnail : `https://servi-compras.com.ar/uploads/${product.thumbnail}`
   img.loading = 'lazy'

   const leftContainer = document.createElement('div')
   leftContainer.className = 'item-left'

   meta.appendChild(code)
   meta.appendChild(category)

   const rightContainer = document.createElement('div')
   rightContainer.className = 'item-right'

   leftContainer.appendChild(title)
   leftContainer.appendChild(meta)
   rightContainer.appendChild(img)

   container.appendChild(leftContainer)
   container.appendChild(rightContainer)
   return container
}

async function search() {
   const params = []
   if (DATA.query) params.push(`query=${DATA.query}`)
   if (DATA.brand) params.push(`brand=${DATA.brand}`)
   if (DATA.model) params.push(`model=${DATA.model}`)

   const response = await fetch(`/api/products/search?${params.join('&')}`)
   const data = await response.json()

   const { recommends, results } = data

   const options = document.createElement('div')
   const products = document.createElement('div')

   const items = document.createElement('div')
   items.className = 'right items'
   results.hits
      .slice(0, 4)
      .map(getProduct)
      .forEach((p) => items.appendChild(p))

   const relateds = document.createElement('div')
   relateds.className = 'related'

   recommends?.hits?.slice(0, 3).forEach((p) => {
      const prod = document.createElement('div')
      const title = document.createElement('a')
      title.className = 'title'
      title.href = `/product/view/${p.objectID}`
      title.innerText = p.title

      const img = document.createElement('img')
      img.src = isValidUrl(p.thumbnail) ? p.thumbnail : `https://servi-compras.com.ar/uploads/${p.thumbnail}`
      prod.appendChild(img)
      prod.appendChild(title)
      relateds.appendChild(prod)
   })

   products.appendChild(items)
   products.appendChild(relateds)

   options.className = 'left options-container'
   products.className = 'right'

   const t_brand = document.createElement('p')
   t_brand.className = 'section-title'
   t_brand.innerText = 'Marcas'
   options.appendChild(t_brand)

   const _brands = Object.entries(results?.facets?.brand || {})
   const brands = _brands
      .sort(([_, a], [_1, b]) => b - a)
      .slice(0, 5)
      .map(([key]) => key)
   brands.forEach((b) => {
      const li = document.createElement('li')
      li.dataset.type = 'brand'
      li.innerHTML = `<p>${b}<p>`
      if (b === DATA.brand) li.className = 'active'

      li.addEventListener('click', () => {
         const brands = options.querySelectorAll('[data-type="brand"]')
         brands.forEach((b) => (b.className = ''))
         li.className = 'active'
         DATA.brand = b
      })
      options.appendChild(li)
   })

   const t_modelos = document.createElement('p')
   t_modelos.className = 'section-title'
   t_modelos.innerText = 'Modelos'
   options.appendChild(t_modelos)
   const _models = Object.entries(results?.facets?.model || {})
   const models = _models
      .sort(([_, a], [_1, b]) => b - a)
      .slice(0, 5)
      .map(([key]) => key)
   models.forEach((b) => {
      const li = document.createElement('li')
      li.dataset.type = 'model'
      li.innerHTML = `<p>${b}<p>`
      if (b === DATA.model) li.className = 'active'

      li.addEventListener('click', () => {
         const brands = options.querySelectorAll('[data-type="model"]')
         brands.forEach((b) => (b.className = ''))
         li.className = 'active'
         DATA.model = b
      })
      options.appendChild(li)
   })

   const t_clear = document.createElement('p')
   t_clear.dataset.type = 'clear'
   t_clear.className = 'clear'
   t_clear.innerText = 'Limpiar filtros'
   t_clear.addEventListener('click', () => {
      const brands = options.querySelectorAll('[data-type="brand"]')
      const models = options.querySelectorAll('[data-type="model"]')
      const filters = [...brands, ...models]
      filters.forEach((f) => (f.className = ''))
      DATA.brand = null
      DATA.model = null
   })
   options.appendChild(t_clear)

   return [options, products]
}

async function main(searchbar) {
   if (!searchbar) return console.warn('No se encontró el searchbar')

   const input = searchbar.querySelector('input[type="text"]')
   if (!input) return console.warn('No se encontró el input')

   const button = searchbar.querySelector('button')
   if (!button) return console.warn('No se encontró el botón')

   const loader = Loader()
   let curr_options = null
   let curr_results = null

   input.addEventListener('input', () => {
      DATA.query = input.value
      clearTimeout(DATA.timeout)

      DATA.timeout = setTimeout(async () => {
         if (DATA.query.trim().length > 0) {
            const container = searchbar.querySelector(`[data-name="search-results"]`)

            container.innerHTML = ''
            container.appendChild(loader)
            const [_options, _results] = await search(DATA.query.trim())
            container.style.display = 'flex'
            curr_options = _options
            curr_results = _results
            container.removeChild(loader)

            container.appendChild(curr_options)
            container.appendChild(curr_results)

            let brand_filters = curr_options.querySelectorAll('[data-type="brand"]')
            let model_filters = curr_options.querySelectorAll('[data-type="model"]')
            let clear_btn = curr_options.querySelector('[data-type="clear"]')
            let filters = [...brand_filters, ...model_filters]

            function handleEvents() {
               clear_btn.addEventListener('click', async () => {
                  DATA.brand = null
                  DATA.model = null

                  container.appendChild(loader)
                  container.removeChild(curr_options)
                  container.removeChild(curr_results)

                  const [_opts, _res] = await search(DATA.query)
                  container.style.display = 'flex'

                  container.removeChild(loader)
                  container.appendChild(_opts)
                  container.appendChild(_res)

                  curr_options = _opts
                  curr_results = _res

                  brand_filters = curr_options.querySelectorAll('[data-type="brand"]')
                  model_filters = curr_options.querySelectorAll('[data-type="model"]')
                  clear_btn = curr_options.querySelector('[data-type="clear"]')
                  filters = [...brand_filters, ...model_filters]
                  handleEvents()
               })

               filters.forEach((f) => {
                  f.addEventListener('click', async () => {
                     container.appendChild(loader)
                     container.removeChild(curr_options)
                     container.removeChild(curr_results)

                     const [_opts, _res] = await search(DATA.query)
                     container.style.display = 'flex'

                     container.removeChild(loader)
                     container.appendChild(_opts)
                     container.appendChild(_res)

                     curr_options = _opts
                     curr_results = _res

                     brand_filters = curr_options.querySelectorAll('[data-type="brand"]')
                     model_filters = curr_options.querySelectorAll('[data-type="model"]')
                     clear_btn = curr_options.querySelector('[data-type="clear"]')
                     filters = [...brand_filters, ...model_filters]
                     handleEvents()
                  })
               })
            }

            handleEvents()
         }
      }, 300)
   })

   button.addEventListener('click', () => {
      if (DATA.query.trim()) {
         window.location.href = `/products?query=${encodeURIComponent(DATA.query.trim())}`
      }
   })
}

window.addEventListener('DOMContentLoaded', (e) => {
   const searchbars = document.querySelectorAll('[data-name=searchbar]')
   searchbars.forEach((searchbar) => {
      const container = searchbar.querySelector(`[data-name="search-results"]`)
      container.style.display = 'none'
      main(searchbar)
      window.addEventListener('click', (e) => {
         const isSearchbar = e.target.closest(`[data-name="searchbar"]`)
         if (!isSearchbar) container.style.display = 'none'
      })
   })
})

function Loader() {
   const div = document.createElement('div')
   div.className = 'loader-container'
   const _loader = document.createElement('div')
   _loader.className = 'loader'

   const text = document.createElement('p')
   text.innerText = 'Cargando resultados...'

   div.appendChild(_loader)
   div.appendChild(text)
   return div
}
